'use strict';

function parse(reader) {
    reader.readUInt8('data.params.pin_index');
    reader.readBit(2, 'data.params.pin_status');
    reader.readUInt32LE('data.params.pulse_duration');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_2/common/rule/output-status-parser.js